import ConversationTranslationSettingsAPI from 'dashboard/api/conversationTranslationSettings';
import types from '../../../mutation-types';

const mergeTranslationSettingsIntoConversation = (conversation, translationSettings) => ({
  ...conversation,
  additional_attributes: {
    ...(conversation.additional_attributes || {}),
    translation_settings: translationSettings,
  },
});

export default {
  async saveConversationTranslationSettings(
    { commit, state },
    { conversationId, translationSettings }
  ) {
    const { data } = await ConversationTranslationSettingsAPI.update(
      conversationId,
      translationSettings
    );

    const chat = state.allConversations.find(c => c.id === conversationId);
    if (chat) {
      commit(
        types.UPDATE_CONVERSATION,
        mergeTranslationSettingsIntoConversation(
          chat,
          data.translation_settings
        )
      );
    }

    return data.translation_settings;
  },
};
